import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, UsersIcon, CalendarIcon, ClockIcon } from 'lucide-react';
interface TableData {
  id: number;
  x: number;
  y: number;
  section: string;
  capacity: number;
  price: string;
}
const tables: TableData[] = [{
  id: 1,
  x: 120,
  y: 280,
  section: 'Main Floor',
  capacity: 4,
  price: '$500 min'
}, {
  id: 2,
  x: 170,
  y: 310,
  section: 'Main Floor',
  capacity: 6,
  price: '$700 min'
}, {
  id: 3,
  x: 220,
  y: 280,
  section: 'Main Floor',
  capacity: 4,
  price: '$500 min'
}, {
  id: 4,
  x: 270,
  y: 310,
  section: 'Main Floor',
  capacity: 8,
  price: '$900 min'
}, {
  id: 5,
  x: 320,
  y: 280,
  section: 'Main Floor',
  capacity: 4,
  price: '$500 min'
}, {
  id: 6,
  x: 120,
  y: 190,
  section: 'VIP Section',
  capacity: 6,
  price: '$1,200 min'
}, {
  id: 7,
  x: 180,
  y: 190,
  section: 'VIP Section',
  capacity: 8,
  price: '$1,500 min'
}, {
  id: 8,
  x: 240,
  y: 190,
  section: 'VIP Section',
  capacity: 6,
  price: '$1,200 min'
}, {
  id: 9,
  x: 300,
  y: 190,
  section: 'VIP Section',
  capacity: 10,
  price: '$2,000 min'
}, {
  id: 10,
  x: 420,
  y: 150,
  section: 'Skybox Suite',
  capacity: 15,
  price: '$3,000 min'
}, {
  id: 11,
  x: 420,
  y: 200,
  section: 'Skybox Suite',
  capacity: 20,
  price: '$4,000 min'
}, {
  id: 12,
  x: 100,
  y: 380,
  section: 'Bar Lounge',
  capacity: 4,
  price: '$300 min'
}, {
  id: 13,
  x: 160,
  y: 380,
  section: 'Bar Lounge',
  capacity: 4,
  price: '$300 min'
}, {
  id: 14,
  x: 220,
  y: 380,
  section: 'Bar Lounge',
  capacity: 2,
  price: '$200 min'
}];
export function FloorMap() {
  const [selectedTable, setSelectedTable] = useState<TableData | null>(null);
  const [hoveredTable, setHoveredTable] = useState<number | null>(null);
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  return <section className="w-full bg-[#050505] py-20 px-6 relative" data-id="element-138">
      <div className="max-w-7xl mx-auto" data-id="element-139">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-14" data-id="element-140">
          <span className="font-inter text-xs tracking-[0.4em] text-[#C9A84C]/70 uppercase" data-id="element-141">
            Interactive
          </span>
          <h2 className="font-montserrat font-black text-4xl sm:text-5xl tracking-widest text-white mt-2" data-id="element-142">
            FIND YOUR SPOT
          </h2>
          <div className="w-16 h-px bg-[#C9A84C]/50 mx-auto mt-4" data-id="element-143" />
          <p className="font-inter font-light text-white/50 text-sm mt-4" data-id="element-144">
            Click any table to make a reservation
          </p>
        </motion.div>

        {/* Map container */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="relative rounded-2xl overflow-hidden border border-[#C9A84C]/20 mx-auto" style={{
        maxWidth: 600,
        background: '#0a0a0a'
      }} data-id="element-145">
          <svg viewBox="0 0 560 460" className="w-full" style={{
          display: 'block'
        }} data-id="element-146">
            {/* Background */}
            <rect width="560" height="460" fill="#0a0a0a" data-id="element-147" />

            {/* Outer walls */}
            <rect x="60" y="40" width="440" height="380" rx="8" fill="none" stroke="#C9A84C" strokeWidth="1.5" strokeOpacity="0.4" data-id="element-148" />

            {/* Main entrance */}
            <rect x="230" y="400" width="100" height="20" rx="4" fill="#C9A84C" fillOpacity="0.15" stroke="#C9A84C" strokeWidth="1" strokeOpacity="0.6" data-id="element-149" />
            <text x="280" y="414" textAnchor="middle" fill="#C9A84C" fontSize="8" fontFamily="Montserrat" fontWeight="700" letterSpacing="2" opacity="0.8" data-id="element-150">
              ENTRANCE
            </text>

            {/* Stage */}
            <rect x="80" y="55" width="400" height="70" rx="6" fill="#C9A84C" fillOpacity="0.08" stroke="#C9A84C" strokeWidth="1" strokeOpacity="0.5" data-id="element-151" />
            <text x="280" y="96" textAnchor="middle" fill="#C9A84C" fontSize="10" fontFamily="Montserrat" fontWeight="800" letterSpacing="3" opacity="0.9" data-id="element-152">
              STAGE
            </text>

            {/* Dance floor */}
            <rect x="130" y="230" width="220" height="120" rx="6" fill="#C9A84C" fillOpacity="0.04" stroke="#C9A84C" strokeWidth="1" strokeOpacity="0.25" strokeDasharray="4,4" data-id="element-153" />
            <text x="240" y="296" textAnchor="middle" fill="#C9A84C" fontSize="9" fontFamily="Montserrat" fontWeight="700" letterSpacing="2" opacity="0.5" data-id="element-154">
              DANCE FLOOR
            </text>

            {/* Bar */}
            <rect x="370" y="240" width="110" height="30" rx="4" fill="#C9A84C" fillOpacity="0.12" stroke="#C9A84C" strokeWidth="1" strokeOpacity="0.5" data-id="element-155" />
            <text x="425" y="259" textAnchor="middle" fill="#C9A84C" fontSize="8" fontFamily="Montserrat" fontWeight="700" letterSpacing="2" opacity="0.9" data-id="element-156">
              BAR
            </text>

            {/* VIP Section area */}
            <rect x="80" y="155" width="280" height="60" rx="4" fill="#C9A84C" fillOpacity="0.05" stroke="#C9A84C" strokeWidth="0.75" strokeOpacity="0.3" strokeDasharray="3,3" data-id="element-157" />
            <text x="90" y="148" fill="#C9A84C" fontSize="7" fontFamily="Montserrat" fontWeight="700" letterSpacing="2" opacity="0.6" data-id="element-158">
              VIP SECTION
            </text>

            {/* Skybox */}
            <rect x="380" y="110" width="100" height="110" rx="4" fill="#C9A84C" fillOpacity="0.07" stroke="#C9A84C" strokeWidth="1" strokeOpacity="0.4" data-id="element-159" />
            <text x="430" y="130" textAnchor="middle" fill="#C9A84C" fontSize="7" fontFamily="Montserrat" fontWeight="700" letterSpacing="1.5" opacity="0.8" data-id="element-160">
              SKYBOX
            </text>

            {/* Bar lounge area */}
            <rect x="80" y="355" width="200" height="50" rx="4" fill="#C9A84C" fillOpacity="0.05" stroke="#C9A84C" strokeWidth="0.75" strokeOpacity="0.3" strokeDasharray="3,3" data-id="element-161" />
            <text x="90" y="350" fill="#C9A84C" fontSize="7" fontFamily="Montserrat" fontWeight="700" letterSpacing="2" opacity="0.6" data-id="element-162">
              BAR LOUNGE
            </text>

            {/* Table hotspots */}
            {tables.map(table => <g key={table.id} data-id="element-163">
                {/* Pulse ring */}
                <circle cx={table.x} cy={table.y} r="14" fill="none" stroke="#C9A84C" strokeWidth="1" strokeOpacity={hoveredTable === table.id ? 0.6 : 0.2} className="table-hotspot" data-id="element-164" />
                {/* Main circle */}
                <circle cx={table.x} cy={table.y} r="9" fill={hoveredTable === table.id ? '#C9A84C' : '#C9A84C33'} stroke="#C9A84C" strokeWidth="1.5" strokeOpacity={hoveredTable === table.id ? 1 : 0.7} style={{
              cursor: 'pointer',
              transition: 'all 0.2s'
            }} onMouseEnter={() => setHoveredTable(table.id)} onMouseLeave={() => setHoveredTable(null)} onClick={() => setSelectedTable(table)} data-id="element-165" />
                {/* Table number */}
                <text x={table.x} y={table.y + 4} textAnchor="middle" fill={hoveredTable === table.id ? '#050505' : '#C9A84C'} fontSize="7" fontFamily="Montserrat" fontWeight="800" style={{
              cursor: 'pointer',
              pointerEvents: 'none'
            }} data-id="element-166">
                  {table.id}
                </text>

                {/* Tooltip */}
                {hoveredTable === table.id && <g data-id="element-167">
                    <rect x={table.x - 40} y={table.y - 38} width="80" height="26" rx="4" fill="#050505" stroke="#C9A84C" strokeWidth="0.75" strokeOpacity="0.6" data-id="element-168" />
                    <text x={table.x} y={table.y - 28} textAnchor="middle" fill="#C9A84C" fontSize="7" fontFamily="Montserrat" fontWeight="700" data-id="element-169">
                      TABLE {table.id}
                    </text>
                    <text x={table.x} y={table.y - 18} textAnchor="middle" fill="rgba(255,255,255,0.6)" fontSize="6.5" fontFamily="Inter" data-id="element-170">
                      {table.capacity} guests
                    </text>
                  </g>}
              </g>)}
          </svg>

          {/* Legend */}
          <div className="flex flex-wrap gap-4 p-4 border-t border-[#C9A84C]/10" data-id="element-171">
            <div className="flex items-center gap-2" data-id="element-172">
              <div className="w-3 h-3 rounded-full bg-[#C9A84C]/30 border border-[#C9A84C]" data-id="element-173" />
              <span className="font-inter text-xs text-white/50" data-id="element-174">
                Available Table
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-175">
              <div className="w-3 h-3 rounded-full bg-[#C9A84C]" data-id="element-176" />
              <span className="font-inter text-xs text-white/50" data-id="element-177">Selected</span>
            </div>
            <div className="ml-auto font-inter text-xs text-white/30" data-id="element-178">
              {tables.length} tables available
            </div>
          </div>
        </motion.div>
      </div>

      {/* Side Panel Drawer */}
      <AnimatePresence data-id="element-179">
        {selectedTable && <>
            {/* Overlay */}
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.3
        }} className="fixed inset-0 z-40 bg-black/60" onClick={() => setSelectedTable(null)} data-id="element-180" />

            {/* Drawer */}
            <motion.div initial={{
          x: '100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '100%'
        }} transition={{
          type: 'spring',
          stiffness: 300,
          damping: 35
        }} className="fixed top-0 right-0 bottom-0 z-50 flex flex-col overflow-y-auto" style={{
          width: 'min(380px, 100vw)',
          background: 'rgba(5,5,5,0.95)',
          backdropFilter: 'blur(24px)',
          WebkitBackdropFilter: 'blur(24px)',
          borderLeft: '1px solid rgba(201,168,76,0.3)'
        }} data-id="element-181">
              {/* Drawer header */}
              <div className="flex items-center justify-between p-6 border-b border-[#C9A84C]/15" data-id="element-182">
                <div data-id="element-183">
                  <p className="font-montserrat text-[10px] tracking-widest text-[#C9A84C]/70 mb-1" data-id="element-184">
                    RESERVATION
                  </p>
                  <h3 className="font-montserrat font-black text-xl tracking-widest text-white" data-id="element-185">
                    TABLE {selectedTable.id}
                  </h3>
                </div>
                <button onClick={() => setSelectedTable(null)} className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:border-[#C9A84C]/60 hover:text-[#C9A84C] transition-all" aria-label="Close drawer" data-id="element-186">
                  <XIcon size={16} data-id="element-187" />
                </button>
              </div>

              {/* Table info */}
              <div className="p-6 border-b border-[#C9A84C]/10" data-id="element-188">
                <div className="grid grid-cols-2 gap-3" data-id="element-189">
                  <div className="bg-white/5 rounded-xl p-3 border border-[#C9A84C]/10" data-id="element-190">
                    <p className="font-montserrat text-[9px] tracking-widest text-white/40 mb-1" data-id="element-191">
                      SECTION
                    </p>
                    <p className="font-montserrat font-700 text-sm text-white" data-id="element-192">
                      {selectedTable.section}
                    </p>
                  </div>
                  <div className="bg-white/5 rounded-xl p-3 border border-[#C9A84C]/10" data-id="element-193">
                    <div className="flex items-center gap-1.5 mb-1" data-id="element-194">
                      <UsersIcon size={10} className="text-[#C9A84C]" data-id="element-195" />
                      <p className="font-montserrat text-[9px] tracking-widest text-white/40" data-id="element-196">
                        CAPACITY
                      </p>
                    </div>
                    <p className="font-montserrat font-700 text-sm text-white" data-id="element-197">
                      Up to {selectedTable.capacity}
                    </p>
                  </div>
                  <div className="col-span-2 bg-[#C9A84C]/10 rounded-xl p-3 border border-[#C9A84C]/20" data-id="element-198">
                    <p className="font-montserrat text-[9px] tracking-widest text-white/40 mb-1" data-id="element-199">
                      MINIMUM SPEND
                    </p>
                    <p className="font-montserrat font-black text-lg text-[#C9A84C]" data-id="element-200">
                      {selectedTable.price}
                    </p>
                  </div>
                </div>
              </div>

              {/* Form */}
              <div className="p-6 flex-1" data-id="element-201">
                <p className="font-montserrat text-[10px] tracking-widest text-white/40 mb-4" data-id="element-202">
                  SELECT DATE & TIME
                </p>

                <div className="space-y-3 mb-6" data-id="element-203">
                  <div className="relative" data-id="element-204">
                    <CalendarIcon size={13} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#C9A84C] pointer-events-none" data-id="element-205" />
                    <input type="date" value={date} onChange={e => setDate(e.target.value)} className="w-full bg-white/5 border border-[#C9A84C]/20 rounded-lg pl-9 pr-3 py-3 text-white/80 text-sm font-inter focus:outline-none focus:border-[#C9A84C]/60 transition-colors [color-scheme:dark]" data-id="element-206" />
                  </div>

                  <div className="relative" data-id="element-207">
                    <ClockIcon size={13} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#C9A84C] pointer-events-none z-10" data-id="element-208" />
                    <select value={time} onChange={e => setTime(e.target.value)} className="w-full bg-white/5 border border-[#C9A84C]/20 rounded-lg pl-9 pr-3 py-3 text-white/80 text-sm font-inter focus:outline-none focus:border-[#C9A84C]/60 transition-colors appearance-none cursor-pointer" style={{
                  background: 'rgba(5,5,5,0.9)'
                }} data-id="element-209">
                      <option value="" style={{
                    background: '#050505'
                  }} data-id="element-210">
                        Select arrival time
                      </option>
                      {['9:00 PM', '9:30 PM', '10:00 PM', '10:30 PM', '11:00 PM', '11:30 PM', '12:00 AM', '12:30 AM', '1:00 AM'].map(t => <option key={t} value={t} style={{
                    background: '#050505'
                  }} data-id="element-211">
                          {t}
                        </option>)}
                    </select>
                  </div>
                </div>

                <div className="bg-white/5 rounded-xl p-4 border border-[#C9A84C]/10 mb-6" data-id="element-212">
                  <p className="font-inter text-xs text-white/50 leading-relaxed" data-id="element-213">
                    A $200 deposit is required to confirm your reservation.
                    Remaining balance applied to minimum spend.
                  </p>
                </div>

                <button className="w-full font-montserrat font-700 text-xs tracking-widest bg-[#C9A84C] text-[#050505] py-4 rounded-xl hover:bg-[#E8C97A] transition-colors duration-300" data-id="element-214">
                  CONFIRM RESERVATION
                </button>
              </div>
            </motion.div>
          </>}
      </AnimatePresence>
    </section>;
}